import React, { Component } from "react";
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import findIndex from 'lodash/findIndex';
import { connect } from 'react-redux';
import * as actionCreators from './../../../modules/actions/index';
import {importOrgChartSteps,uploadFileInstruction,mapType,reviewInstruction, officeHierarchy, computeOfficeKey} from '../../../utils/constants';
import {deepClone} from '../../../utils/copyObject';
import Steps from '../../../components/Steps/Steps';
import MapHierarchy from "./MapHierarchy";
import PickOffice from "./PickOffice";
import InviteAdmin from "./InviteAdmin";
import UploadFile from './../Components/UploadFile/UploadFile';
import MatchColumns from './../Components/MatchColumns/MatchColumns';
import Review from './../Components/Review/Review';
import {getFlatDataFromTree,getTreeFromFlatData} from 'react-sortable-tree';
// import MatchColumns from "./MatchColumns";
import * as url from './../../../utils/url';
import axios from './../../../axios';

class OrgChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType: 'a-z',
    }
  }

  // computeOfficeKey = (office) => {
  //   let org = this.props.user.profile.organizationId.name.replace(/^\s+|\s+$/g, '');

  //   let result = Date.now() + [...office].reduce((acc, currVal)=> acc.concat(currVal.charCodeAt())) + "orgName" + org
  //   return result
  // } 

  componentDidMount() {
    window.scrollTo(0, 0);
    // this.getMappedColumn();
  }

  getMappedColumn = () => {
    // axios.get('https://devapi.ouroffice.io/mappings/v1/mapping/5bb770b4c2f1ba2119fba68a').then((response) => {
    //   // let {total, unread, docs, pageNumber, isContinue} = response.data.data;
    //   // console.log("itsReponse", response);
    // }).catch((error) => {
    //   console.log(error);
    // });
  }

  handleFileUpload = (fields,data,file) => {
    this.props.saveAllColumnsAndData(fields,data,file.name);
    console.log(this.props)
    this.props.nextStep();
  }

  handleMatchColumns = (matchedColumn) => {
    const {rowData} = this.props.orgChart;
    // console.log(matchedColumn);
    // console.log(rowData);
    let org = this.props.user.profile.organizationId.name
    const allOffices = rowData.map((row) => {
      if(row[matchedColumn] != undefined) {
        return row[matchedColumn]
      }
    });
    const allUniqueOffices = Object.keys(groupBy(allOffices));
    // console.log(allUniqueOffices);

    // ------------ ACTUAL code below -----------
    let officeHierarchy = filter(allUniqueOffices,(o) => o != 'undefined').map((office,i) => {
      const o = {};
      o.id = office;
      o.officeKey = computeOfficeKey(office, this.props.user.profile.organizationId)
      o.title = office;
      o.subtitle = '';
      o.children = [];
      return o;
    });
    
    officeHierarchy=sortBy(officeHierarchy, "title")




    // ***************************************************************************************************
    // ***************************************************************************************************
    // ********************** ALL CODE FOR AM GENERAL to COPY ORG CHART **********************************
    // ***************************************************************************************************
    // ***************************************************************************************************
    // ***************************************************************************************************
    // const flat = getFlatDataFromTree({
    //   treeData : oldHierarchy,
    //   getNodeKey: ({ node }) => node.id,
    //   ignoreCollapsed: false
    // })

    // let tempHierarchy = filter(flat,(o) => o != 'undefined').map((office,i) => {
    //   const o = {...office, ...office.node}
    //   o.id = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
    //   o.node.id  = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
    //   o.node.officeKey = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
    //   o.officeKey = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
    //   o.title = office.node.title;
    //   o.subtitle = '';
    //   return o;
    // });


    // let officeHierarchy =  getTreeFromFlatData({
    //   flatData: tempHierarchy.map(e=> {
    //     return {
    //       ...e,
    //       officeKey: e.officeKey,
    //       // id: e.officeKey
    //     }
    //   }),
    //   getKey: ( node ) => node.officeKey,
    //   getParentKey: ( node ) => node.parentNode,
    //   rootKey: null
    // })
    

    // officeHierarchy=oldHierarchy


    

    this.props.saveMatchedColumn(matchedColumn);
    this.props.saveOfficeHierarchy(officeHierarchy);
   
    this.props.nextStep();
  }

  handleHierarchyMapped = () => {
    const {rowData,officeHierarchy} = this.props.orgChart;
    // const {officeHierarchy} = this.state
    // console.log('off1--->',officeHierarchy)
    console.log('hierarchy MAPPED!')
    const flat = getFlatDataFromTree({treeData : officeHierarchy,getNodeKey: ({ node }) => node.id,ignoreCollapsed: false})
    const allOfficePaths = flat.map((o) => o.path.join('#'));
    this.props.saveAllOfficeMaterialPaths(allOfficePaths);
    this.props.saveAllOffices(allOfficePaths.map((path) => {
      const o = {};
      o.officePath = path;
      o.officeName = path.split('#').pop();
      return o;
    }));
    this.props.saveAllOfficeMaterialPathsWithInvitation(sortBy(allOfficePaths.map((path) => {
      const o = {};
      o.officePath = path;
      o.isInvited = false;
      o.invitedUsers = []
      o.officeName = path.split('#').pop();
      o.officeKey = computeOfficeKey(path.split('#').pop(), this.props.user.profile.organizationId)

      // o.officeKey = computeOfficeKey(path.split('#').pop())
      return o;
    }),(o) => o.officeName));
    this.props.nextStep();
  }

  handleNextStep = () => {
    const {currentStep,matchedColumns,rowData} = this.props.orgChart;
    this.props.nextStep();
  }

  handleFlaggedAdminOfficeSelected = (value) => {
    this.props.flaggedAdminOfficeSelected(value);
  }

  handleCancelInvitation = (user,officePath) => {
    const {allOfficesWithInvitations} = this.props.orgChart;
    const allOffices = deepClone(allOfficesWithInvitations);
    const i = findIndex(allOffices,{officePath : officePath});
    const invitedUsers = allOffices[i].invitedUsers;
    const userIndex = findIndex(invitedUsers,{email : user.email});
    allOffices[i].invitedUsers.splice(userIndex,1);
    if(allOffices[i].invitedUsers.length === 0) {
      allOffices[i].isInvited = false;
    }
    this.props.saveAllOfficeMaterialPathsWithInvitation(allOffices);
  }

  handleOnAdminInvited = (users,office) => {
    console.log('admins INVITED')
    const {allOfficesWithInvitations} = this.props.orgChart;
    const allOffices = deepClone(allOfficesWithInvitations);
    const i = findIndex(allOffices,{officePath : office.officePath});
    const selectedOffice = allOffices[i];
    // console.log(users);
    let allInvitedUsers = deepClone(selectedOffice.invitedUsers);
    allInvitedUsers = allInvitedUsers.concat(users);
    const uniqueEmails = uniqBy(allInvitedUsers,'email');
    allOffices.splice(i,1,{officeName : selectedOffice.officeName, 
      officePath : selectedOffice.officePath,
      officeKey:selectedOffice.officeKey,
      isInvited:true,invitedUsers:uniqueEmails});
    //allOffices.push();
    // console.log(allOffices);
    // return;
    this.props.saveAllOfficeMaterialPathsWithInvitation(allOffices);
  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    });
  }

  handleImport = () => {
    // console.log("prepare data for server");
    console.log('import --- ', this.props)
    // return
    const {officeHierarchy,selectedFlaggedAdminOffice,
      allOfficesWithInvitations,matchedColumn, file, fileName} = this.props.orgChart;
      
      // console.log('off1--->',officeHierarchy)
    // const flatOfficeHierarchy = getFlatDataFromTree({treeData : officeHierarchy,getNodeKey: ({ node }) => node.id,ignoreCollapsed: false})
    // const hierarchyMapping = flatOfficeHierarchy.map((office) => {
    //   const o = {};
    //   o.officeName = office.node.title;
    //   o.path = office.path.join('#');

    //   o.officeKey = computeOfficeKey(office.node.title,this.props.user.profile.organizationId)
    //   o.children = office.node.children.map((child) => {
    //     const c = {};
    //     c.name = child.title;
    //     c.path = office.path.join('#') + '#' + child.title;
    //     return c;
    //   });
    //   // o.officeKey = Date.now() + [...str].reduce((acc, currVal)=> acc.concat(currVal.charCodeAt())) + "orgName" + org
    //   o.parentName = office.parentNode ? office.parentNode.title : ''
    //   return o;
    // });


    const p1 = {
      // hierarchyMappings : hierarchyMapping,
      staticHierarchy : officeHierarchy,
      fileName:file,
      mappedColumns : [matchedColumn]
    };
    console.log(officeHierarchy)
    // console.log(JSON.stringify(p1));
    // const selfOffice = find(hierarchyMapping,{officeName : selectedFlaggedAdminOffice.value});
    // const p2 = {officeHierarchyPath : selfOffice.path, officeKey: selfOffice.officeKey};
    // const p3 = filter(allOfficesWithInvitations,(o) => o.isInvited).map((office) => {
    //   const o = {};
      
    //   o.officeKey = computeOfficeKey(office.title.split('#').pop(), this.props.user.profile.organizationId.name )
    //   o.inviteeArr = office.invitedUsers.map((u) => {
    //     const e = {};
    //     e.email = u.email;
    //     if(u.firstName) {
    //       e.firstName = u.firstName;
    //     }
    //     if(u.lastName) {
    //       e.lastName = u.lastName;
    //     }
    //     return e;
    //   });
    //   o.version = 1
    //   // o.officeHierarchyPath = office.officePath;
    //   return o;
    // })
    // console.log(p1);
    // console.log(this.props);
    // console.log('before submit')
    // return
    let that = this
    axios.post(url.saveHierarchyMapping,p1).then(resp => {
     
      // .then(axios.spread((self,inviteAdmin) => {
        // console.log(self.data.data);
        // this.props.updateProfileInfoSuccess(self.data.data);
        // this.props.history.push('map-gender');
      // }));
      let orgId = {
        organizationId: {
          ...resp.data.data
        }
      }
      // console.log(resp.data.data)
      // return
      that.props.updateProfileInfoSuccess(orgId);
      that.props.history.push('map-gender');
    })
  }

  handleOfficePicked = () => {
    const {selectedFlaggedAdminOffice} = this.props.orgChart;
    // console.log(selectedFlaggedAdminOffice);
    if(selectedFlaggedAdminOffice) {
      this.props.nextStep();
    }
  }

  handleSortChanged = (sort) => {
    this.setState({sortType : sort});
  }

  render() {
    const {currentStep,matchedColumns,matchedColumn,allOffices,allColumns,rowData,allOfficesWithInvitations,
      officeHierarchy,allOfficeMaterialPaths,selectedFlaggedAdminOffice,file, fileName} = this.props.orgChart;
    const {searchedTerm,sortType} = this.state;

    // console.log(this.state, this.props.orgChart)

    console.log('this.props.orgChart----', this.props.orgChart);
    return (
      <div>
        <div className="org-chart-title mb30">Import Organizational Chart</div>
        <Steps steps={importOrgChartSteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.orgChart}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            fileName={fileName}
            labelSize={3}
            labelText="Office Hierarchy File"
            type={mapType.orgChart}
            allowedFileSize={20}
            uploadFileHint="(Only .csv files)"
            onFileUpload={this.handleFileUpload}
          /> :
          currentStep === 2 ?
          <MatchColumns
            goBack={this.props.goBack}
            top="mt40"
            instruction="Please match the column in your .csv file which contains the lowest level (i.e, immediate) organization each employee belongs to. In the next step, you will drag and drop these organizations to form your Enterprise hierarchy."
            csvFields={allColumns}
            csvData={rowData}
            type={mapType.orgChart}
            fileName={fileName}
            matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
            allowMoreColumnsMatch={false}
            nextBtnTxt='Continue'
            onMatchedColumn={this.handleMatchColumns}
            {...this.props}
          /> :
          currentStep === 3 ? 
          <MapHierarchy
            goBack={this.props.goBack}
            nextStep={this.handleNextStep}
            matchedColumns={matchedColumns}
            fileName={fileName}
            fileName = {file.name}
            officeHierarchy={officeHierarchy}
            onHierarchyChange={(h) => this.props.saveOfficeHierarchy(h)}
            onHierarchyMapped={this.handleHierarchyMapped}
            {...this.props}
          /> : 
          // currentStep === 4 ?
          // <PickOffice
          //   goBack={this.props.goBack}
          //   nextStep={this.handleOfficePicked}
          //   allOffices={allOffices}
          //   allOfficeMaterialPaths={allOfficeMaterialPaths}
          //   flaggedAdminOfficeSelected={this.handleFlaggedAdminOfficeSelected}
          //   selectedFlaggedAdminOffice={selectedFlaggedAdminOffice}
          // />
          //  :
     
          currentStep === 4?
          <Review
            top="mt40"
            instruction={reviewInstruction.orgChart}
            goBack={this.props.goBack}
            nextBtnAction={this.handleImport}
            file={file}
            fileName={fileName}
            type={mapType.orgChart}
            nextBtnTxt='Import'
            reviewHeading="Please review the above information one last time."
            {...this.props}
          />: null
        }
      </div>
    ) 
  }
}

const mapStateToProps = state => {
	// console.log('State after Login', state);
	return {
		user : state.user,
		isPasswordChanged: state.user.profile.isPasswordChanged,
		isProfileDetailsUpdated : state.user.profile.isProfileDetailsUpdated,
		isAuthenticated: (state.user.profile.autherizationToken && state.user.profile.autherizationToken !== null)
	}
}
const mapDispatchToProps = dispatch => {
	return {
		onLoginSuccess: (data) => dispatch(actionCreators.loginSuccess(data)),
		onFetchOfficeSuccess : (data) => dispatch(actionCreators.fetchOfficeSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OrgChart);